var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "container py-5"
  }, [_vm.loading ? _c('div', {
    staticClass: "text-center my-5"
  }, [_vm._m(0)]) : _vm.error ? _c('div', {
    staticClass: "alert alert-danger",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v(" " + _vm._s(_vm.error) + " ")]) : _c('div', [_c('div', [_c('b-button', {
    attrs: {
      "variant": "link"
    },
    on: {
      "click": function ($event) {
        return _vm.$router.go(-1);
      }
    }
  }, [_c('b-icon', {
    attrs: {
      "icon": "arrow-left-short"
    }
  })], 1)], 1), _c('h1', {
    staticClass: "mb-4 text-center"
  }, [_vm._v(_vm._s(_vm.terms.title))]), _vm._l(_vm.terms.sections, function (section) {
    return _c('div', {
      key: section._id,
      staticClass: "mb-4 pb-3"
    }, [_c('h5', {}, [_vm._v(_vm._s(section.subtitle))]), _c('div', {
      staticClass: "tick",
      domProps: {
        "innerHTML": _vm._s(section.description)
      }
    })]);
  })], 2)]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "spinner-border text-primary",
    attrs: {
      "role": "status"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Loading...")])]);

}]

export { render, staticRenderFns }